const byteConverter = (bytes, decimals = 2) => {
    if (!+bytes) return '0 MB'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${Math.round(parseFloat((bytes / Math.pow(k, i)).toFixed(dm)))} ${sizes[i]}`
}

export default byteConverter